'use strict'

import Splide from '@splidejs/splide'

export const sliders = (() => {

    const carousels = []
    let currentCarouselStates = {}

    const swapPagination = (paginationContainers) => {
        const firstPaginationStyles = window.getComputedStyle(paginationContainers[0])
        const secondPaginationStyles = window.getComputedStyle(paginationContainers[1])

        let paginationContainer = null

        if (firstPaginationStyles.display != 'none' && secondPaginationStyles.display == 'none') {
            paginationContainer = paginationContainers[0]
        } else {
            paginationContainer = paginationContainers[1]
        }

        const pagination = paginationContainers[0].querySelector('.splide__pagination') || paginationContainers[1].querySelector('.splide__pagination')

        paginationContainer.appendChild(pagination)
    }

    const onMounted = (slider) => {
        const root = slider.root

        if (!root) return

        const pagintaionContainers = root.querySelectorAll('.splide__pagination__container')

        if (pagintaionContainers.length != 2) return

        // Check that second pagination is visible in fact
        window.onresize = () => {
            swapPagination(pagintaionContainers)
        }

        swapPagination(pagintaionContainers)
    }

    const initSliders = () => {
        // Get sliders synced to some other slider
        const _sliderContainersSynced = document.querySelectorAll('.splide[data-synced-to]:not(.is-initialized):not(#timeline')

        _sliderContainersSynced.forEach(sliderContainer => {
            const newSlider = new Splide(sliderContainer)

            newSlider.on('mounted', () => onMounted(newSlider))

            carousels.push(newSlider)

            // Check for synced slider
            const syncedSliderContainerId = sliderContainer.dataset.syncedTo
            if (syncedSliderContainerId) {
                const syncedSliderContainer = document.getElementById(syncedSliderContainerId)

                if (syncedSliderContainer) {
                    const syncedSlider = new Splide(syncedSliderContainer)
                    newSlider.sync(syncedSlider)
                    carousels.push(syncedSlider)
                    syncedSlider.mount()
                }
            }

            newSlider.mount()
        })

        // Get rest of sliders
        const _sliderContainers = document.querySelectorAll('.splide:not(.is-initialized):not(#timeline)')

        _sliderContainers.forEach(sliderContainer => {
            const newSlider = new Splide(sliderContainer)

            newSlider.on('mounted', () => onMounted(newSlider))

            carousels.push(newSlider)

            newSlider.mount()
        })

    }

    const stopSliders = () => {
        carousels.forEach(carousel => {
            const _id = carousel.root.id
            const _autoplay = carousel.Components.Autoplay
            const _isPlaying = !_autoplay.isPaused()

            currentCarouselStates[_id] = _isPlaying

            if (_isPlaying) _autoplay.pause()
        })
    }

    const resumeSliders = () => {
        carousels.forEach(carousel => {
            const _id = carousel.root.id
            const _autoplay = carousel.Components.Autoplay

            if (currentCarouselStates[_id]) _autoplay.play()
        })
    }

    const init = () => {
        initSliders()

        window.PortBlakely.initSliders = initSliders
        window.PortBlakely.stopSliders = stopSliders
        window.PortBlakely.resumeSliders = resumeSliders
    }

    return {
        init
    }
})()